<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <ScalesForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ScalesForm from './components/ScaleForm'
export default {
  name: 'Scale',
  components: {
    ScalesForm,
  },
  data: function () {
    return {}
  },
}
</script>
